import React from 'react';
import { Modal, Button } from 'antd';

// import { playSound } from '../utils/sounds';
const analysisSteps = [
  { count: 25, label: 'Personality Analysis', color: 'bg-purple-200' },
  { count: 50, label: 'Thought Pattern Analysis', color: 'bg-blue-200' },
  { count: 100, label: 'Blind Spot Analysis', color: 'bg-orange-100' },
  { count: 150, label: 'Personalized Roadmap', color: 'bg-green-100' },
];

export default function WelcomeAnalysisModal({ open, onGotIt }) {
  const handleGotIt = () => {
    // playSound && playSound('pop');
    onGotIt && onGotIt();
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={handleGotIt}
      footer={null}
      closable={false}
      maskClosable={true}
      width={500}
      classNames={{ content: '!bg-white md:mb-16', mask: '!blur-md', wrapper: '' }}
    >
      <div className="text-center text-black">
        <h1 className="mt-4 mb-2 font-extrabold text-center text-black text-3xl">Welcome!</h1>
        <p className="my-2 text-[15px] text-gray-500 px-3 leading-tight">
          Each analysis will happen automatically as you reach these message counts.
        </p>

        <div className="mt-12 mb-8 text-left">
          {analysisSteps.map((step) => (
            <div className="flex items-center mb-4 max-w-[300px] mx-auto" key={step.count}>
              <div className={`relative w-9 h-9 rounded-full flex items-center justify-center mr-4 ${step.color}`}>
                <video
                  src={'/anim/orb-animation.mp4'}
                  className="absolute inset-0 w-full h-full object-cover rounded-full"
                  loop
                  muted
                  autoPlay
                  playsInline
                  webkit-playsinline="true"
                />
                <span className="relative z-10 font-bold text-white text-base">{step.count}</span>
              </div>
              <span className="font-bold text-black text-base">{step.label}</span>
            </div>
          ))}
        </div>
        <Button
          type="primary"
          className="w-full h-14 rounded-full font-bold text-lg mt-2"
          onClick={handleGotIt}
          size="large"
        >
          Got it!
        </Button>
      </div>
    </Modal>
  );
}
